










import { computed, defineComponent, onUnmounted, ref } from "@vue/composition-api";
import emitter from "@/lib/emitter";
import { $t } from "@/lib/i18nHelpers";
import { PreventLogout } from "@/types";
import { EVENTS } from "@/const";
import BaseButton from "@/components/BaseButton";
import BaseConfirm from "@/components/BaseConfirm";

export default defineComponent({
  name: "LogoutConfirm",
  components: { BaseButton, BaseConfirm },
  setup(_, { root }) {
    const show = ref(false);
    const loading = ref(false);
    const preventLogoutStack = ref<PreventLogout[]>([]);

    const preventLogout = computed(() => !!preventLogoutStack.value.length);
    const message = computed(
      () => preventLogoutStack.value.map(i => i.text).find(i => !!i) ?? $t("Are you sure you want to logout?")
    );

    const onPreventLogout = (data?: PreventLogout): void => {
      if (!data) return;
      if (!data.value) {
        preventLogoutStack.value = preventLogoutStack.value.filter(i => i.type !== data.type);
        return;
      }
      preventLogoutStack.value.push(data);
    };

    const doLogout = () => {
      root.$router.push({ name: "logout" });
    };

    const onCancel = () => {
      show.value = false;
    };

    const onConfirm = async () => {
      try {
        loading.value = true;
        await Promise.all(preventLogoutStack.value.map(i => i.cb && i.cb()));
        preventLogoutStack.value = [];
        show.value = false;
        doLogout();
      } finally {
        loading.value = false;
      }
    };

    const onLogout = () => {
      if (preventLogout.value) {
        show.value = true;
        return;
      }
      doLogout();
    };

    emitter.on<void>(EVENTS.USER_LOGOUT, onLogout);
    emitter.on<PreventLogout>(EVENTS.PREVENT_LOGOUT, onPreventLogout);

    onUnmounted(() => {
      emitter.off<void>(EVENTS.USER_LOGOUT, onLogout);
      emitter.off<PreventLogout>(EVENTS.PREVENT_LOGOUT, onPreventLogout);
    });

    return { show, message, loading, onCancel, onConfirm };
  },
});
